import { DELETEOBJECTIVE_SUCCESS, DELETEOBJECTIVE_FAIL } from "../actionTypes";

const initialState = {
    user: null,
};

const deleteObjectiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETEOBJECTIVE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETEOBJECTIVE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default deleteObjectiveReducer;
